"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomBackdrop = exports.useBackdropStyles = exports.getModalBg = void 0;
// @ts-nocheck
const styles_1 = require("@material-ui/core/styles");
const Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
/**
 * Returns a theme-aware modal/dialog background color (rgba white for light, black for dark)
 */
function getModalBg(theme, alpha = 0.5) {
    return theme.palette.type === 'dark' ? `rgba(0,0,0,${alpha})` : `rgba(255,255,255,${alpha})`;
}
exports.getModalBg = getModalBg;
/**
 * Utility hook for modal backdrop styles with theme-aware background color.
 * Usage: const backdropClasses = useBackdropStyles();
 */
exports.useBackdropStyles = (0, styles_1.makeStyles)((theme) => ({
    backdrop: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(0,0,0,0.5) !important' : 'rgba(0,0,0,0.4) !important',
    },
}));
exports.CustomBackdrop = (0, styles_1.styled)(Backdrop_1.default)(({ theme }) => ({
    zIndex: -1,
    position: 'fixed',
    inset: 0,
    WebkitTapHighlightColor: 'transparent',
}));
//# sourceMappingURL=useBackdropStyles.js.map